'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msActivityHistorySelect', {
    bindings: {
      hasHistoryView: '<',
      userResponses: '<'
    },
    templateUrl: 'vnext/templates/history-dropdown.html',
    controller: msActivityHistorySelectCtrl
  });

  msActivityHistorySelectCtrl.$inject = ['activityRouter'];

  function msActivityHistorySelectCtrl(activityRouter) {
    var vm = this;
    vm.viewResponse = _viewResponse;
    vm.selectedResponse = null;
    vm.showResponses = false;

    ///////////////////////////////

    function _viewResponse() {
      if (vm.selectedResponse !== null) {
        activityRouter.showHistory({
          response: vm.selectedResponse.id
        });

        vm.showResponses = false;
      }
    }
  }
})();